// Every Purchases endpoint is admin-gated, so every call must carry the token.
// Most existing product pages send no Authorization header at all — copying one
// of those wholesale would produce a page that 401s and shows an empty table.
// Routing all Purchases traffic through here makes that impossible to forget.
import axios from 'axios';
import API_BASE_URL from '../../../Config/api';
import authHeader from '../../Customer/authHeader';

const base = `${API_BASE_URL}/api/purchases`;

// The API answers 401 for an expired session and 403 for a staff account that
// isn't an admin. They need different words on screen, so keep them apart.
export function describeError(error, fallback = 'Something went wrong.') {
  const status = error?.response?.status;
  if (status === 401) return 'Your session has expired. Please sign in again.';
  if (status === 403) return 'Purchases is restricted to admin accounts.';
  return error?.response?.data?.error || error?.message || fallback;
}

export const getDashboard = () => axios.get(`${base}/dashboard`, authHeader()).then((r) => r.data);
export const getInvoices = () => axios.get(`${base}/invoices`, authHeader()).then((r) => r.data);
export const getInvoice = (id) => axios.get(`${base}/invoices/${id}`, authHeader()).then((r) => r.data);
export const deleteInvoice = (id) => axios.delete(`${base}/invoices/${id}`, authHeader()).then((r) => r.data);
export const getCosts = () => axios.get(`${base}/costs`, authHeader()).then((r) => r.data);
export const getTrend = (sku) =>
  axios.get(`${base}/costs/${encodeURIComponent(sku)}/trend`, authHeader()).then((r) => r.data);

export const parseFile = (file, meta = {}) => {
  const form = new FormData();
  form.append('file', file);
  Object.entries(meta).forEach(([k, v]) => { if (v) form.append(k, v); });
  return axios.post(`${base}/parse`, form, {
    ...authHeader(),
    headers: { ...(authHeader().headers || {}), 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);
};

// Only the token travels back, never the parsed rows: the consolidated sheet is
// ~230 KB as JSON and the server's body parser caps at 100 KB.
export const commitParse = (token, onConflict = 'replace') =>
  axios.post(`${base}/commit`, { token, onConflict }, authHeader()).then((r) => r.data);

export const formatInr = (value) =>
  value === null || value === undefined || value === ''
    ? '—'
    : `₹${Number(value).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
